export const ORGANIZATION_LIST = 'organization-list';
export const PERMISSION_LIST = 'permission-list';
export const USER_PERMISSION = 'user-permission';
export const ADMIN_PERMISSION_GROUP_LIST = 'admin-permission-group-list';
export const ADMIN_ORG_PERMISSION_GROUP_LIST = 'admin-org-permission-list';
export const ORG_PERMISSION_GROUP_LIST = 'org-permission-group-list';
export const ADMIN_STAFF_LIST = 'admin-staff-list';
export const ADMIN_STAFF_PERMISSION_GROUP_LIST = 'admin-staff-permission-group-list';
export const ADMIN_STAFF_ORG_PERMISSION_GROUP_LIST = 'admin-staff-org-permission-group-list';
export const PERMISSIONS = 'permissions';
export const ORG_ADMIN_PERMISSION_GROUP_LIST = 'org-admin-permission-list';
export const ORG_STAFF_PERMISSION_GROUP_OPTIONS = 'org-staff-permission-group-options';
export const ORG_STAFF_LIST = 'org-staff-list';
export const VENUE_PERMISSION_GROUP_LIST = 'venue-permission-group-list';
export const VENUE_LIST = 'venue-list';
export const VENUE_LIST_USERS = 'venue-list-users';
export const VENUE_LIST_MENU = 'venue-list-menu';
export const VENUE_OPTIONS = 'venue-options';
export const VENUE_SETTINGS = 'venue-settings';
export const VENUE_MENU_COPY_FROM = 'venue-menu-copy-from';
export const MENU_IMPORT_BATCH = 'menu-import-batch';
export const MENU_IMPORT_BATCHES = 'menu-import-batches';
export const MENU_IMPORT_QUOTA = 'menu-import-quota';
export const VENUE_USERS_COPY = 'venue-users-copy';
export const SCHEDULE_STATUS = 'schedule-status';
export const STAFFS_WITH_SCHEDULES_AND_SHIFT = 'staffs-with-schedules-and-shift';
export const USER_ROLES = 'user-roles';
export const USERS_LIST = 'users-list';
export const ORG_SETTINGS = 'org-settings';
export const TMA_BRANDING = 'tma-branding';
export const TMA_PUBLIC_BRANDING = 'tma-public-branding';
export const FEATURE_LIST = 'feature-list';
export const SUBSCRIPTION_PLANS_LIST = 'subscription-plans-list';
export const PLAN_FEATURES_LIST = 'plan-features-list';
export const ADDON_PLANS_LIST = 'addon-plans-list';
export const ORG_SUBSCRIPTION_PLANS_LIST = 'org-subscription-plans-list';
export const ORG_INVOICES_LIST = 'org-invoices-list';
export const ORG_SUBSCRIPTION_DETAILS = 'org-subscription-details';
export const ORG_SUBSCRIPTION_INFO = 'org-subscription-info';
export const ORG_SUBSCRIPTION_PORTAL = 'org-subscription-portal';
